import { getMonogramFromName } from 'util/participant';
import React from 'react';
import { Typography, useTheme } from '@web-chat-core/ui-kit';
import {
    Avatar,
    AvatarImage,
    MessageContentWrapper,
    MessageText,
    MessageTime,
    MessageWithAvatarWrapper,
    MessageWrapper,
    SenderName,
} from './view';
import { MessageContent } from './MessageContent';

export type MessageProps = {
    avatar: string;
    name: string;
    own: boolean;
    time: string;
    text: string;
    showName: boolean;
    sid: string;
    last: boolean;
};

export const Message = React.memo(({ avatar, name, own, time, text, showName, sid, last }: MessageProps) => {
    const theme = useTheme();

    const showAvatarImage = !own && last && !!avatar;
    const showAvatarMonogram = !own && last && !avatar;
    const withMargin = !own && !last;

    return (
        <MessageWithAvatarWrapper own={own} last={last}>
            {showAvatarImage && <AvatarImage src={avatar} draggable="false" />}
            {showAvatarMonogram && (
                <Avatar sid={sid} withName={showName}>
                    <Typography variant="caption4" color={theme.root.colors.basicColors.white['100%']}>
                        {getMonogramFromName(name)}
                    </Typography>
                </Avatar>
            )}
            <MessageWrapper own={own} withMargin={withMargin}>
                {showName ? (
                    <SenderName sid={sid} variant="body4">
                        {name}
                    </SenderName>
                ) : null}
                <MessageContentWrapper>
                    <MessageText>
                        <MessageContent sid={sid} text={text} />
                        <MessageTime>{time}</MessageTime>
                    </MessageText>
                </MessageContentWrapper>
            </MessageWrapper>
        </MessageWithAvatarWrapper>
    );
});

Message.displayName = 'Message';
